module.exports = __webpack_public_path__ + "static/img/OKBtn.f87eb6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/OKBtn.png
// module id = 6CCN
// module chunks = 1